import isEmpty from 'lodash/isEmpty';
import { GetServerSideProps } from 'next';
import { NextSeo } from 'next-seo';
import Head from 'next/head';
import Vejpongosot120years from 'src/components/sections/section-events/vejpongosot120years/footer';
import SectionOne from 'src/components/sections/section-events/vejpongosot120years/section-one';
import _footer from 'src/components/sections/section-events/vejpongosot120years/section-six';
import SectionThree from 'src/components/sections/section-events/vejpongosot120years/section-three';
import SectionTwo from 'src/components/sections/section-events/vejpongosot120years/section-two';
import { APP_URL, IS_NO_ROBOT_INDEX } from 'src/constants';
import { IMAGE_DEFAULT, WEB_DESC, WEB_KEYWORD, WEB_NAME, WEB_TITLE, WEB_URL } from 'src/constants/layout';
import { GET } from 'src/services';
import { convertDatasets } from 'src/utils/datasets';
import { convertObjPath, escapeChar, timestamp } from 'src/utils/helper';
import styled from 'styled-components';

function index({ sectionOne, sectionTwo, sectionThree, sectionFour, sectionFive, footer, _footer, fetchDataSet, background }: any) {
  const desc = 'เวชพงศ์โอสถ ธุรกิจที่สืบทอดคุณค่าจากรุ่นสู่รุ่น ด้วยหลักปรัชญา กตัญญู ขยันหมั่นเพียร และซื่อสัตย์ สร้างความเชื่อมั่นและความสำเร็จในวงการสมุนไพรไทย';
  const background_img = convertDatasets(background, 'background-image', true);
  return (
    <>
      <NextSeo
        noindex={IS_NO_ROBOT_INDEX}
        nofollow={IS_NO_ROBOT_INDEX}
        title={'เวชพงศ์โอสถ: สืบสานปรัชญา กตัญญู ขยันหมั่นเพียร และซื่อสัตย์ สู่ความสำเร็จ'}
        description={desc || WEB_DESC}
        openGraph={{
          type: 'article',
          locale: 'en_US',
          site_name: WEB_NAME,
          title: 'เวชพงศ์โอสถ: สืบสานปรัชญา กตัญญู ขยันหมั่นเพียร และซื่อสัตย์ สู่ความสำเร็จ',
          description: desc || WEB_DESC,
          url: `${APP_URL}/vejpongosot120years`,
          images: [
            {
              url: 'https://image.thepeople.co/images/vejpongosot120years/defau_t-vejpongosot120years.png',
              width: 1920,
              height: 1080,
              alt: WEB_NAME
            }
          ]
        }}
        additionalMetaTags={[
          {
            name: 'keywords',
            content: WEB_KEYWORD
          }
        ]}
      />
      {/* --------------------------------- HEADER --------------------------------- */}
      <Head>
        <link rel='canonical' href={`${APP_URL}/vejpongosot120years`} />
        <meta property='twitter:title' content={'เวชพงศ์โอสถ: สืบสานปรัชญา กตัญญู ขยันหมั่นเพียร และซื่อสัตย์ สู่ความสำเร็จ'} />
        <meta property='twitter:description' content={desc || WEB_DESC} />
        <meta property='twitter:image' content={'https://image.thepeople.co/images/vejpongosot120years/defau_t-vejpongosot120years.png'} />
        {/* ------------------------------- Truehit -------------------------------- */}
        <script
          type='text/javascript'
          dangerouslySetInnerHTML={{
            __html: `
                    __th_page="vejpongosot120years";
                  `
          }}
        />
        {/* ---------------------------- SNIPPET : WebSite --------------------------- */}
        <script
          type='application/ld+json'
          dangerouslySetInnerHTML={{
            __html: `
                    {
                      "@context": "https://schema.org",
                      "@type": "WebSite",
                      "name": "${WEB_NAME}",
                      "url": "${WEB_URL.WEB}",
                      "description": "${escapeChar(desc) || WEB_DESC}",
                      "sameAs": [
                        "${WEB_URL.FACEBOOK}",
                        "${WEB_URL.YOUTUBE}",
                        "${WEB_URL.INSTAGRAM}",
                        "${WEB_URL.TWITTER}"
                      ],
                      "potentialAction": {
                        "@type": "SearchAction",
                        "target": "${WEB_URL.WEB}search?q={search_term_string}",
                        "query-input": "required name=search_term_string"
                      }
                    }
                  `
          }}
        />
        {/* ---------------------------- SNIPPET : WebPage --------------------------- */}
        <script
          type='application/ld+json'
          dangerouslySetInnerHTML={{
            __html: ` 
                    { 
                      "@context": "http://schema.org", 
                      "@type": "WebPage", 
                      "name": "${escapeChar('เวชพงศ์โอสถ: สืบสานปรัชญา กตัญญู ขยันหมั่นเพียร และซื่อสัตย์ สู่ความสำเร็จ') || WEB_TITLE}", 
                      "description": "${escapeChar(desc) || WEB_DESC}", 
                      "publisher": { 
                        "@type": "ProfilePage", 
                        "name": "${WEB_NAME}" 
                      } 
                    } 
                  `
          }}
        />
        {/* ------------------------ SNIPPET : BreadcrumbList ------------------------ */}
        <script
          type='application/ld+json'
          dangerouslySetInnerHTML={{
            __html: ` 
                    { 
                      "@context": "http://schema.org", 
                      "@type": "BreadcrumbList", 
                      "itemListElement": [ 
                        { 
                          "@type": "ListItem", 
                          "position": 1, 
                          "name": "หน้าแรก", 
                          "item": "${APP_URL}" 
                        }, 
                        { 
                          "@type": "ListItem", 
                          "position": 2, 
                          "name": "vejpongosot120years", 
                          "item": "${APP_URL}/vejpongosot120years" 
                        }
                      ] 
                    } 
                  `
          }}
        />
      </Head>
      <PageWrapper background={background_img}>
        <h1 className='seo-checker'>เวชพงศ์โอสถ: สืบสานปรัชญา กตัญญู ขยันหมั่นเพียร และซื่อสัตย์ สู่ความสำเร็จ</h1>
        {!isEmpty(sectionOne?.dataSet) ? <SectionOne data={sectionOne?.dataSet} /> : null}
        {!isEmpty(sectionTwo?.dataSet) ? <SectionTwo data={sectionTwo?.dataSet} /> : null}
        {!isEmpty(sectionThree?.dataSet) ? <SectionThree data={sectionThree?.dataSet} /> : null}
        <Vejpongosot120years data={footer} dataset={_footer} />
      </PageWrapper>
    </>
  );
}

interface StyledProps {
  background: string;
}

const PageWrapper = styled.div<StyledProps>`
  background-image: url(${props => props?.background});
  background-size: contain;
  background-position: center;
  background-repeat: repeat;
  width: 100%;
  position: relative;
  overflow: hidden;
  .seo-checker {
    display: none;
  }
`;
export const getServerSideProps: GetServerSideProps = async () => {
  const initProps: any = {
    statusCode: 200,
    errMessage: null,
    background: {
      dataSet: []
    },
    sectionOne: {
      dataSet: []
    },
    sectionTwo: {
      dataSet: []
    },
    sectionThree: {
      dataSet: []
    },
    sectionFour: {
      dataSet: []
    },
    sectionFive: {
      data: []
    },
    _footer: {
      data: [],
      dataSet: []
    },
    fetchDataSet: [],
    footer: []
  };
  try {
    const fetchDataSet = await GET('/api/datasets');
    if (!isEmpty(fetchDataSet)) {
      const background = convertDatasets(fetchDataSet, 'vejpongosot120years-background', false)[0] || [];
      const sectionOne = convertDatasets(fetchDataSet, 'vejpongosot120years-1', false)[0] || [];
      const sectionTwo = convertDatasets(fetchDataSet, 'vejpongosot120years-2', false)[0] || [];
      const sectionThree = convertDatasets(fetchDataSet, 'vejpongosot120years-3', false)[0] || [];
      const _footer = convertDatasets(fetchDataSet, 'vejpongosot120years-footer', false)[0] || [];

      initProps.background.dataSet = sectionOne;
      initProps.sectionOne.dataSet = sectionOne;
      initProps.sectionTwo.dataSet = sectionTwo;
      initProps.sectionThree.dataSet = sectionThree;
      initProps.fetchDataSet = fetchDataSet;
      initProps.background = background;
      initProps.footer = _footer;
      if (!isEmpty(_footer)) {
        const res6 = await GET(`/api/search/tag${convertObjPath({ name: convertDatasets(_footer, 'tags', true) })}&limit=${convertDatasets(_footer, 'limit', true)[0] || 2}`, false, true);
        if (!isEmpty(res6)) {
          initProps._footer.data = res6?.data;
        }
      }
    }
  } catch (err: any) {
    console.error(`${timestamp()} ==========> PAGE_GAME_CHANGER ERROR : `, err.message);
    initProps.errMessage = err.message;
    initProps.statusCode = err?.response?.status || 500;
  }

  return {
    props: initProps
  };
};

export default index;
